/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbVisiteClasseGridDto
 */
export interface FcbVisiteClasseGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbVisiteClasseGridDto
     */
    nom?: string | null;
}

/**
 * Check if a given object implements the FcbVisiteClasseGridDto interface.
 */
export function instanceOfFcbVisiteClasseGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbVisiteClasseGridDtoFromJSON(json: any): FcbVisiteClasseGridDto {
    return FcbVisiteClasseGridDtoFromJSONTyped(json, false);
}

export function FcbVisiteClasseGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbVisiteClasseGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
    };
}

export function FcbVisiteClasseGridDtoToJSON(value?: FcbVisiteClasseGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': value.nom,
    };
}

